import loadable from '@loadable/component';
import ConnectionRelativePaths from './paths';
var CreatorMarketplace = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'creatorMarketplace' */'@/pages/find-creators/creator-marketplace');
});
var CreatorDetail = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'creatorProfile' */'@/pages/find-creators/creator-detail');
});
var CreatorLeaderboard = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'creatorProfile' */'@/pages/find-creators/creator-leaderboard');
});
var FindMCN = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'findMCN' */'@/pages/find-mcn/mcn-list');
});
var MCNDetail = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'MCNDetail' */'@/pages/find-mcn/mcn-detail');
});
var MCNShare = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'MCNShare' */'@/pages/find-mcn/mcn-share');
});
var TargetInvitation = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'targetInvitation' */'@/pages/find-creators/target-invitation/list');
});
var TargetInvitationDetail = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'targetInvitationDetail' */'@/pages/find-creators/target-invitation/detail');
});
var TargetInvitationCreate = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'targetInvitationCreate' */'@/pages/find-creators/target-invitation/create');
});
var TargetInvitationEdit = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'targetInvitationEdit' */'@/pages/find-creators/target-invitation/edit');
});
var FlatFeeDetail = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'flatFeeDetail' */'@/pages/find-creators/flat-fee/detail');
});
var FlatFeeCreate = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'flatFeeCreate' */'@/pages/find-creators/flat-fee/create');
});
var TargetInvitationSelect = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'targetInvitationSelect' */'@/pages/find-creators/flat-fee/select-create');
});
var CreatorManagement = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'creatorManagement' */'@/pages/creator-management/creator-management-list');
});
var CreatorBulkIMManagement = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'CreatorBulkIMManagement' */'@/pages/creator-management/bulk-im-edit');
});
var TargetInvitationCampaignDetail = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'targetInvitationCampaignDetail' */'@/pages/find-creators/target-invitation-campaign/detail');
});
var TargetInvitationCampaignCreate = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'targetInvitationCampaignCreate' */'@/pages/find-creators/target-invitation-campaign/create');
});
var TargetInvitationCampaignEdit = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'targetInvitationCampaignEdit' */'@/pages/find-creators/target-invitation-campaign/edit');
});
var TargetInvitationCampaignDescription = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'targetInvitationCampaignDescription' */'@/pages/find-creators/target-invitation-campaign/description');
});
var ConnectQuotaOverview = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'connectQuotaOverview' */'@/pages/quota/overview');
});
var routesConfig = [{
  path: ConnectionRelativePaths.CREATOR_MARKETPLACE,
  component: CreatorMarketplace
}, {
  path: ConnectionRelativePaths.CREATOR_DETAIL,
  component: CreatorDetail
}, {
  path: ConnectionRelativePaths.CREATOR_LEADERBOARD,
  component: CreatorLeaderboard
}, {
  path: ConnectionRelativePaths.FIND_MCN,
  component: FindMCN
}, {
  path: ConnectionRelativePaths.MCN_DETAIL,
  component: MCNDetail
}, {
  path: ConnectionRelativePaths.MCN_SHARE,
  component: MCNShare
}, {
  path: ConnectionRelativePaths.TARGET_INVITATION_LIST,
  component: TargetInvitation
}, {
  path: ConnectionRelativePaths.TARGET_INVITATION_DETAIL,
  component: TargetInvitationDetail
}, {
  path: ConnectionRelativePaths.TARGET_INVITATION_CREATE,
  component: TargetInvitationCreate
}, {
  path: ConnectionRelativePaths.TARGET_INVITATION_EDIT,
  component: TargetInvitationEdit
}, {
  path: ConnectionRelativePaths.FLAT_FEE_DETAIL,
  component: FlatFeeDetail
}, {
  path: ConnectionRelativePaths.FLAT_FEE_CREATE,
  component: FlatFeeCreate
}, {
  path: ConnectionRelativePaths.TARGET_INVITATION_SELECT,
  component: TargetInvitationSelect
}, {
  path: ConnectionRelativePaths.CREATOR_MANAGEMENT,
  component: CreatorManagement
}, {
  path: ConnectionRelativePaths.TARGET_INVITATION_CAMPAIGN_DETAIL,
  component: TargetInvitationCampaignDetail
}, {
  path: ConnectionRelativePaths.TARGET_INVITATION_CAMPAIGN_CREATE,
  component: TargetInvitationCampaignCreate
}, {
  path: ConnectionRelativePaths.TARGET_INVITATION_CAMPAIGN_EDIT,
  component: TargetInvitationCampaignEdit
}, {
  path: ConnectionRelativePaths.TARGET_INVITATION_CAMPAIGN_DESCRIPTION,
  component: TargetInvitationCampaignDescription
}, {
  path: ConnectionRelativePaths.CREATOR_MANAGEMENT_BULK_IM,
  component: CreatorBulkIMManagement
}, {
  path: ConnectionRelativePaths.QUOTA_RULE_OVERVIEW,
  component: ConnectQuotaOverview
}];
export default routesConfig;